<template>
  <div>
    <div class="case-tabs">
      <div :class="['case-tab', 'case-tab-predmet', active_tab == 'kalendar' ? 'active':'']" @click="active_tab = 'kalendar';updateKey++;">Kalendar</div>
      <div :class="['case-tab', 'case-tab-sudionici', active_tab == 'paznja' ? 'active':'']" @click="active_tab = 'paznja';updateKey++;">Potrebna pažnja</div>
      <div :class="['case-tab', 'case-tab-spisi', active_tab == 'nadolazeci' ? 'active':'']" @click="active_tab = 'nadolazeci';updateKey++;">Nadolazeći događaji</div>
      <div :class="['case-tab', 'case-tab-pošta', active_tab == 'rjeseni' ? 'active':'']" @click="active_tab = 'rjeseni';updateKey++;">Riješeni događaji</div>
      <div :class="['case-tab', 'case-tab-pošta', active_tab == 'rocista' ? 'active':'']" @click="active_tab = 'rocista';updateKey++;">Sva ročišta</div>

      <!-- <div class="case-tab case-tab-financije">Putni Nalog</div> -->
    </div>
    <!-- <CaseTab current_tab="Kalendar"/> -->
    <div class="upload-dokumenta-button kalendar-novi-button" style="top:7rem" @click="goToForm">
      Kreiraj novi događaj
      <div class="upload-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
        >
          <g>
            <g>
              <path
                fill="#fff"
                d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z"
              />
            </g>
          </g>
        </svg>
      </div>
    </div>
    <div class="kalendar-notifikacija" style="display:none">
      <div class="kalendar-notif-ikona">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="66"
          height="66"
          viewBox="0 0 66 66"
        >
          <g>
            <g>
              <path
                fill="#feedf3"
                d="M33 0c18.225 0 33 14.775 33 33S51.225 66 33 66 0 51.225 0 33 14.775 0 33 0z"
              />
            </g>
            <g>
              <path
                fill="#fd4087"
                d="M46.632 23.472v18.95a3.238 3.238 0 0 1-3.238 3.231H22.238A3.238 3.238 0 0 1 19 42.423V23.472a3.238 3.238 0 0 1 3.238-3.23h1.295v-2.154h2.16v2.153H39.94v-2.153h2.159v2.153h1.295a3.238 3.238 0 0 1 3.238 3.23zm-2.159 4.738H21.16v14.213a1.08 1.08 0 0 0 1.08 1.077h21.155a1.08 1.08 0 0 0 1.08-1.077zm0-4.738a1.08 1.08 0 0 0-1.08-1.077H42.1v2.154h-2.16v-2.154H25.693v2.154h-2.159v-2.154h-1.295a1.08 1.08 0 0 0-1.08 1.077v2.584h23.315zM23.102 30.47h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zm4.318 0h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zm4.318 0h2.158v2.153h-2.158zm-17.27 4.307h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zm4.318 0h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zm-12.952 4.307h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zm4.318 0h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zm4.318-4.307h2.158v2.153h-2.158z"
              />
            </g>
          </g>
        </svg>
      </div>
      <div class="kalendar-notif-info">
        <div class="vrsta-eventa event-grey">predmet 2021/101</div>
        <div class="kalendar-notif-title">
          Rok za predaju žalbe Legroulx v Pitre
        </div>
        <div class="vrijeme-lokacija-event">
          <div class="vrijeme-event">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="16"
              viewBox="0 0 15 16"
            >
              <g>
                <g>
                  <path
                    fill="#606076"
                    d="M15 7.765A7.476 7.476 0 1 1 7.524.289 7.484 7.484 0 0 1 15 7.765zM8.058 3.493a.534.534 0 0 0-1.068 0v3.738H3.252a.534.534 0 0 0 0 1.068h4.272a.534.534 0 0 0 .534-.534z"
                  />
                </g>
              </g>
            </svg>
            09:30 - 10:30
          </div>
          <div class="lokacija-event">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="20"
              viewBox="0 0 17 20"
            >
              <g>
                <g>
                  <path
                    fill="#606076"
                    d="M11.314 7.843a2.465 2.465 0 0 1-2.463 2.462A2.465 2.465 0 0 1 6.39 7.843a2.465 2.465 0 0 1 2.462-2.464 2.466 2.466 0 0 1 2.463 2.464zM17 8.15c0 4.404-4.163 8.067-6.4 10.035-.31.274-.58.51-.793.71-.268.25-.612.375-.956.375-.343 0-.687-.125-.955-.375-.214-.2-.482-.436-.793-.71-2.237-1.968-6.4-5.63-6.4-10.035 0-2.177.848-4.223 2.387-5.763A8.094 8.094 0 0 1 8.85 0c2.177 0 4.223.848 5.762 2.387A8.098 8.098 0 0 1 17 8.15zm-4.558-.308c0-1.98-1.61-3.591-3.59-3.591A3.595 3.595 0 0 0 5.26 7.842c0 1.98 1.61 3.592 3.59 3.592 1.98 0 3.591-1.611 3.591-3.592z"
                  />
                </g>
              </g>
            </svg>
            Braće Radića 99, Varaždin
          </div>
          <div class="alarm-event">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="17"
              viewBox="0 0 15 17"
            >
              <g>
                <g>
                  <path
                    fill="#606076"
                    d="M14.387 8.006a.685.685 0 0 1-.685-.685c0-1.923-.748-3.73-2.107-5.09a.685.685 0 1 1 .97-.97 8.516 8.516 0 0 1 2.507 6.06.686.686 0 0 1-.685.685zm-13.702 0A.686.686 0 0 1 0 7.321C0 5.03.89 2.88 2.508 1.26a.684.684 0 1 1 .969.97A7.154 7.154 0 0 0 1.37 7.32a.686.686 0 0 1-.685.685zm13.702 5.052a1.2 1.2 0 0 1-1.199 1.2H1.884a1.2 1.2 0 0 1-.78-2.111 4.598 4.598 0 0 0 1.636-3.52v-1.91c0-2.413 1.79-4.41 4.111-4.745v-.74a.685.685 0 1 1 1.37 0v.74a4.802 4.802 0 0 1 4.11 4.744v1.912c0 1.356.595 2.637 1.63 3.513.273.234.426.566.426.917zM5.02 14.943h5.034A2.574 2.574 0 0 1 7.536 17a2.574 2.574 0 0 1-2.517-2.057z"
                  />
                </g>
              </g>
            </svg>
          </div>
          <div class="repeat-event">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="17"
              viewBox="0 0 16 17"
            >
              <g>
                <g>
                  <path
                    fill="#606076"
                    d="M16 10.043a3.866 3.866 0 0 1-3.858 3.865H5.97v2.319a.774.774 0 0 1-.771.773.774.774 0 0 1-.483-.17L.86 13.74a.774.774 0 0 1 0-1.208L4.716 9.44a.773.773 0 0 1 1.254.603v2.32h6.172a2.32 2.32 0 0 0 2.315-2.32.772.772 0 1 1 1.543 0zM.57 6.952a3.866 3.866 0 0 1 3.857-3.865h6.172V.768a.773.773 0 0 1 1.254-.604l3.858 3.092a.774.774 0 0 1 0 1.207l-3.858 3.092a.774.774 0 0 1-.817.093.774.774 0 0 1-.437-.696v-2.32H4.427a2.32 2.32 0 0 0-2.315 2.32.772.772 0 1 1-1.543 0z"
                  />
                </g>
              </g>
            </svg>
          </div>
        </div>
        <div class="izvrsi"><a href="#">Izvrši</a></div>
      </div>
    </div>
    <CalendarComponent v-if="active_tab == 'kalendar'" />
    <EventListsComponent v-else :tab_name="active_tab" :key="updateKey"/>
    <!-- <calendar-create-edit
      :accessToken="accessToken"
      :spisList="rootSpisi"
      :caseId="predmet_info.broj_predmeta"
    ></calendar-create-edit> -->
  </div>
</template>

<script>
import auth from "@/services/auth";
import CalendarComponent from "@/components/calendarComponents/CalendarComponent.vue";
import CaseTab from "@/components/caseComponents/CaseTab.vue";
import EventListsComponent from "@/components/calendarComponents/EventListsComponent.vue";
export default {
  components: { CaseTab, CalendarComponent, EventListsComponent},
  data: function () {
    return {
      //CURRENT CASE DATA BEGIN
      accessToken: "",
      active_tab:'kalendar',
      updateKey:0
    };
  },
  methods: {
    goToForm(){
      console.log(this.$router);
      this.$router.push("/kalendar/novi-osobni-dogadaj");
    },
  },
  async created() {
    this.accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
  },
};
</script>

<style>
</style>